export default "__VITE_ASSET__DJzIHwTR__"